var map = {
	"./arrowLeft.svg": 3,
	"./arrowRight.svg": 4,
	"./calendar.svg": 5,
	"./camera.svg": 6,
	"./close.svg": 7,
	"./closecircle.svg": 8,
	"./external.svg": 9,
	"./facebook.svg": 10,
	"./hand.svg": 11,
	"./heart.svg": 12,
	"./instagram.svg": 13,
	"./sample.svg": 14,
	"./scroll.svg": 15,
	"./team.svg": 16,
	"./time.svg": 17,
	"./youtube.svg": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;